import {
  FlowActionAddSavedProperties,
  FlowActionEditSavedProperties,
} from 'lib-shared-tracking';
import { ampli } from 'lib-shared-tracking';

export function trackFlowActionSaved(
  isAction: boolean,
  properties: FlowActionAddSavedProperties | FlowActionEditSavedProperties,
): void {
  isAction
    ? ampli.flowActionAddSaved(properties)
    : ampli.flowActionEditSaved(properties);
}
